module.exports = __webpack_public_path__ + "static/media/icon-incoming.f0800f11.svg";